var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 288,
    viewBox: "0 0 269 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1883_22915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.414 268.827C208.648 268.827 268.827 208.648 268.827 134.414C268.827 60.179 208.648 0 134.414 0C60.179 0 0 60.179 0 134.414C0 208.648 60.179 268.827 134.414 268.827Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.52 82.3371C113.52 82.3371 109.024 64.8532 112.496 56.7524C115.069 50.7472 120.831 46.47 130.965 45.2971C139.003 44.3666 147.933 46.1103 151.17 51.2085C152.765 53.7263 156.112 59.1451 156.738 78.8419L157.402 84.6125L114.388 85.6994L113.528 82.3371H113.52Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.096 90.9148C157.707 89.2181 159.553 87.013 160.475 84.4874C161.625 81.3597 161.507 78.0052 159.607 77.669C158.294 77.4422 157.363 78.0208 156.722 78.8341C155.682 80.1399 155.369 82.0243 155.369 82.0243",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.096 90.9148C157.707 89.2181 159.553 87.013 160.475 84.4874C161.625 81.3597 161.507 78.0052 159.607 77.669C158.294 77.4422 157.363 78.0208 156.722 78.8341C155.682 80.1399 155.369 82.0243 155.369 82.0243",
    stroke: "#1E1F24",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.366 85.2615C115.366 85.2615 113.771 80.5074 110.487 81.649C108.665 82.2824 109.095 85.6055 110.729 88.5143C112.05 90.8601 114.224 92.7367 116.085 94.152",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.366 85.2615C115.366 85.2615 113.771 80.5074 110.487 81.649C108.665 82.2824 109.095 85.6055 110.729 88.5143C112.05 90.8601 114.224 92.7367 116.085 94.152",
    stroke: "#1E1F24",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.199 122.818L125.398 104.341L150.349 105.459L153.884 123.122V137.846L121.199 139.066V122.818Z",
    fill: "white",
    stroke: "#1E1F24",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.692 102.448C148.089 95.0278 142.655 93.1668 136.181 93.6907C129.706 94.2146 124.632 96.8419 125.242 104.348C125.242 104.348 118.267 98.0695 116.288 94.5508C116.75 98.9531 117.188 102.534 117.532 103.778C118.658 107.906 130.48 119.088 139.168 118.65C147.863 118.212 156.096 104.215 156.558 101.807C156.73 100.931 156.487 96.4822 156.081 90.9618C154.048 97.4283 148.692 102.448 148.692 102.448ZM137.596 111.214C132.959 111.589 128.995 109.423 128.627 104.88C128.189 99.5083 131.818 97.5691 136.462 97.1937C141.107 96.8184 145.001 98.2102 145.431 103.527C145.861 108.844 142.241 110.846 137.596 111.222V111.214Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.431 103.512C145.861 108.813 142.241 110.831 137.596 111.206C132.951 111.581 128.995 109.415 128.627 104.872C128.189 99.5004 131.818 97.5612 136.462 97.1859C141.107 96.8106 145.001 98.2024 145.431 103.52V103.512Z",
    fill: "white",
    stroke: "#1E1F24",
    strokeWidth: 0.49,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.289 94.5433C116.21 94.4103 116.148 94.2773 116.085 94.152",
    stroke: "#1E1F24",
    strokeWidth: 0.49,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.096 90.9148C156.096 90.9148 156.089 90.9383 156.081 90.954",
    stroke: "#1E1F24",
    strokeWidth: 0.49,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.089 90.9618C154.056 97.4283 148.699 102.448 148.699 102.448C148.097 95.0278 142.663 93.1668 136.189 93.6907C129.714 94.2146 124.639 96.8419 125.249 104.348C125.249 104.348 118.275 98.0695 116.296 94.5508C115.241 84.3466 114.122 69.748 114.122 69.748C115.71 75.2528 121.426 76.3632 121.426 76.3632C121.426 76.3632 120.659 71.9218 126.579 64.6499C130.168 60.2398 142.913 58.629 147.933 60.3336C150.717 61.2798 153.149 64.7359 153.375 66.0104C153.891 68.9114 155.385 81.2659 156.096 90.9618H156.089Z",
    fill: "white",
    stroke: "#1E1F24",
    strokeWidth: 0.49,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.467 76.2928L134.492 88.9757C134.554 89.7341 135.219 90.2971 135.977 90.2346L138.464 90.0313",
    stroke: "#1E1F24",
    strokeWidth: 0.49,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.242 102.48C137.87 108.391 131.622 103.418 131.622 103.418L143.242 102.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.242 102.48C137.87 108.391 131.622 103.418 131.622 103.418",
    stroke: "#1E1F24",
    strokeWidth: 0.49,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.296 82.1181C126 82.1181 126.571 81.5475 126.571 80.8436C126.571 80.1397 126 79.5691 125.296 79.5691C124.592 79.5691 124.022 80.1397 124.022 80.8436C124.022 81.5475 124.592 82.1181 125.296 82.1181Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.445 80.6481C144.149 80.6481 144.719 80.0775 144.719 79.3736C144.719 78.6697 144.149 78.099 143.445 78.099C142.741 78.099 142.17 78.6697 142.17 79.3736C142.17 80.0775 142.741 80.6481 143.445 80.6481Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5838 179.797C69.5838 179.797 75.808 157.043 83.2129 137.87C87.4431 126.923 105.623 122.841 120.699 123.318C120.699 123.318 123.185 133.03 136.759 132.654C150.334 132.287 153.876 122.129 153.876 122.129C153.876 122.129 171.383 123.083 178.248 123.92C188.523 125.179 205.538 136.626 227.103 189.719L190.939 199.048L193.856 275.262H163.814L88.5925 274.934L69.576 179.789L69.5838 179.797Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 1.53,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.474 174.354H40.3866V275.262H150.474V174.354Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.52 191.142C221.52 191.142 231.584 213.842 232.639 217.752C233.695 221.661 229.48 232.155 211.95 242.312C193.285 253.126 153.368 272.494 149.888 275.262C146.408 278.03 141.036 286.686 138.206 287.554C135.375 288.422 134.953 285.13 134.421 285.021C133.89 284.911 132.083 286.718 130.019 285.685C127.955 284.653 129.636 281.831 127.83 282.049C126.023 282.261 122.317 283.621 122.411 278.359C122.434 277.241 120.096 279.281 118.259 276.42C116.273 273.315 128.346 266.473 127.994 263.33C127.83 261.829 121.754 257.169 120.933 255.534C120.253 254.166 121.989 252.031 124.929 254.072C128.385 256.473 132.036 258.201 134.101 258.756C136.908 259.507 138.394 258.967 141.568 256.613C156.503 245.487 200.338 219.777 201.816 217.603C204.005 214.381 197.906 205.069 194.481 198.704L221.52 191.15V191.142Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7524 243.352C43.5847 243.438 47.205 243.102 54.5083 244.016C59.6455 244.658 58.5274 249.693 56.0487 250.428C56.0487 250.428 60.5682 253.431 55.7984 255.667C55.7984 255.667 59.3718 259.233 54.6803 261.258C54.6803 261.258 56.4083 265.152 52.2094 265.762C48.0104 266.364 39.9018 265.95 38.7524 265.95C38.7524 265.95 36.6021 266.09 36.2659 261.227C35.9374 256.52 35.4605 243.297 38.7524 243.36V243.352Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.778 174.675H86.0747V214.616H104.778V174.675Z",
    fill: "#0C57BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1883_22915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 268.827,
    height: 288,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.7dfbce54dc66834be29e0f57f7494345.svg";
export { ForwardRef as ReactComponent };